import { Component, Input, Output, EventEmitter } from '@angular/core';
import { INITIAL_MODAL_STATE, Modal } from '@shared/models/dialog.model';

@Component({
    selector: 'app-confirmmodal',
    templateUrl: './confirmModal.component.html',
    styleUrls: ['./confirmModal.component.scss']
})
export class ConfirmModalComponent {
    @Input() modal: Modal = INITIAL_MODAL_STATE;

    constructor() { }
}